<template>
    <d2-container type="card" :filename="filename">
        <d2-crud
                :columns="columns"
                :data="data"
                :loading="loading"
                title="留言管理"
                add-mode
                :rowHandle="rowHandle"
                :pagination="pagination"
                :form-template="formTemplate"
                :form-options="formOptions"
                @row-add="handleRowAdd"
                @row-edit="handleRowEdit"
                @row-remove="handleRowRemove"
                @dialog-cancel="handleDialogCancel">
            <el-button slot="headerButton" @click="getData">
                <d2-icon name="refresh"></d2-icon>
            </el-button>
        </d2-crud>

    </d2-container>
</template>

<script>

    import GbookReply from "@/pages/components/gbookReply.vue"

    export default {
        components: {GbookReply},
        name: "index",
        data() {
            return {
                filename: __filename,
                loading: false,
                time: '',
                columns: [
                    {
                        title: 'ID',
                        key: 'id',
                        width:'60'
                    }, {
                        title: '昵称',
                        key: 'user',
                        width: '100'
                    },
                    {
                        title: '邮箱',
                        key: 'mail',
                        width:'150'
                    },
                    {
                        title: '留言',
                        key: 'text',
                    }, {
                        title: '时间',
                        key: 'time',
                        width:'100'
                    }, {
                        title: '显示',
                        key: 'show',
                        formatter(row, index, val) {
                            const value = parseInt(val)
                            if (value === 1) {
                                return '显示'
                            } else {
                                return '不显示'
                            }
                        },
                        width:'80'
                    },
                    {
                        title: 'IP',
                        key: 'ip',
                        width:'120'
                    },
                ],
                data: [],
                rowHandle: {
                    columnHeader: '操作',
                    edit: {
                        icon: 'el-icon-edit',
                        text: '',
                        size: 'small',
                    },
                    remove: {
                        icon: 'el-icon-delete',
                        text: '',
                        size: 'small',
                        fixed: 'right',
                        confirm: true,
                    },
                    custom: [],
                    width:'135'
                },
                gbookform: {
                    name: '',
                    region: ''
                },
                formTemplate: {
                    user: {
                        title: '昵称',
                        value: ''
                    },
                    mail: {
                        title: '邮箱',
                        value: '',
                    },
                    text: {
                        title: '留言',
                        value: '',
                        component: {
                            name: 'el-input',
                            type: "textarea",
                        }
                    },
                    time: {
                        title: '时间',
                        value: '',
                        component: {
                            name: 'el-date-picker',
                            type: "date",
                            'value-format': "yyyy-MM-dd"
                        }
                    },
                    show: {
                        title: '显示',
                        value: 0,
                        component: {
                            name: 'el-select',
                            options: [{
                                value: 0,
                                label: '不显示'
                            }, {
                                value: 1,
                                label: '显示'
                            }]
                        }
                    },
                    ip: {
                        title: 'IP',
                        value: '',
                    },

                },
                formOptions: {
                    labelWidth: '80px',
                    labelPosition: 'left',
                    saveLoading: false
                },
                pagination: {
                    pageSize: 10,
                    layout: 'prev, pager, next, total'
                }
            }
        },
        methods: {
            getReply(id) {
                console.log(id)
            },
            handleRowAdd(row, done) {
                this.formOptions.saveLoading = true
                this.$request({
                    url: 'createGbook.do', data: row
                }).then(res => {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    })
                    done()
                    this.formOptions.saveLoading = false
                }).catch((error) => {
                    this.msg = error
                    this.formOptions.saveLoading = false
                })
            },
            handleRowEdit({index, row}, done) {
                this.formOptions.saveLoading = true
                this.$request({
                    url: 'updateGbookByID.do', data: row,
                }).then(res => {
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    })
                    done()
                    this.formOptions.saveLoading = false
                }).catch((error) => {
                    this.msg = error
                    this.formOptions.saveLoading = false
                })
            },
            handleDialogCancel(done) {
                this.$message({
                    message: '取消编辑',
                    type: 'warning'
                })
                done()
            },
            handleRowRemove({index, row}, done) {
                this.$request({
                    url: 'delGbook.do', data: row
                }).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    done()
                }).catch((error) => {
                    this.msg = error
                })
            },
            getData() {
                const _this = this
                this.loading = true
                this.$request({url: 'getGbooks.do'}).then(res => {
                    _this.data = res
                    _this.loading = false
                })
                    .catch((error) => {
                        this.msg = error
                        _this.loading = false
                    })
            }
        }, created: function () {

            this.getData()
        }
    }
</script>

<style scoped>

</style>
